import React from "react";
import { FooterNovoConhecerSocialProps } from "./FooterNovoConhecerSocial.types";
import { FooterNovoConhecerSocialContainer } from "./FooterNovoConhecerSocial.style";
import { ComponentMapping, Container } from "@adobe/aem-react-editable-components";
import { CoreContainerState } from "@adobe/aem-core-components-react-spa";

export default class FooterNovoConhecerSocial extends Container<
FooterNovoConhecerSocialProps,
  CoreContainerState
> {
  constructor(props: FooterNovoConhecerSocialProps) {
    super(props);

    this.state = {
      componentMapping: this.props.componentMapping || ComponentMapping,
    };
  }

  componentDidMount() {
    this.addNoFollowToLinksSocials();
  }

  componentDidUpdate() {
    this.addNoFollowToLinksSocials();
  }

  addNoFollowToLinksSocials = () => {
    const items = document.querySelectorAll('.footernovoconhecersocial__item');
    items.forEach(item => {
      const cmpImage = item.querySelector('.cmp-image');
      if (cmpImage) {
        const link = cmpImage.querySelector('a');
        if (link) {
          link.setAttribute('rel', 'nofollow');
        }
      }
    });
  };

  render() {
    return (
      <>
        <FooterNovoConhecerSocialContainer>
          <div className="footernovoconhecersocial">
            {this.childComponents &&
              this.childComponents.map((item, k) => {
                if (k < 6) {
                  return (
                    <div key={k} className="footernovoconhecersocial__item">
                      {item}
                    </div>
                  );
                }
                return null;
              })}
          </div>
        </FooterNovoConhecerSocialContainer>
        {this.childComponents.length < 6 && this.placeholderComponent}
      </>
    );
  }
}